import { createFileRoute } from '@tanstack/react-router';
import {
  fetchProductTraceBySalesOrderId,
  fetchTraceGraphBySalesOrderId,
} from '@/api/orders';
import { OrderProductTracingTab } from '@/app/(client)/orders/-components/OrderProductTracingTab';
import {
  productTraceKeys,
  useProductTraceBySalesOrderId,
} from '@/app/(client)/orders/-hooks/useProductTrace';
import {
  traceGraphKeys,
  useTraceGraphBySalesOrderId,
} from '@/app/(client)/orders/-hooks/useTraceGraphBySalesOrderId';
import { Skeleton } from '@/components/ui/skeleton';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/orders/(pages)/(detail)/sales-orders/$soId/products',
)({
  loader: ({ params }) =>
    Promise.all([
      queryClient.ensureQueryData({
        queryKey: productTraceKeys.detail(params.soId),
        queryFn: () => fetchProductTraceBySalesOrderId(params.soId),
      }),
      queryClient.ensureQueryData({
        queryKey: traceGraphKeys.detail(params.soId),
        queryFn: () =>
          fetchTraceGraphBySalesOrderId(params.soId).then(r => r.data),
      }),
    ]),
  component: SalesOrderProductsRoute,
});

function SalesOrderProductsRoute() {
  const { soId } = Route.useParams();
  const { data: productTrace, isLoading } = useProductTraceBySalesOrderId(soId);
  const { data: traceGraph } = useTraceGraphBySalesOrderId(soId);

  const tracingMeta = traceGraph?.meta
    ? { type: traceGraph.meta.type, orderId: traceGraph.meta.orderId }
    : undefined;

  if (isLoading) {
    return (
      <div className='flex flex-col gap-4'>
        <Skeleton className='h-8 w-40' />
        <Skeleton className='w-full rounded-xl h-96' />
      </div>
    );
  }

  return (
    <OrderProductTracingTab
      data={productTrace ?? { layers: [], links: [] }}
      orderId={soId}
      {...(tracingMeta ? { tracingMeta } : {})}
    />
  );
}
